/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototypeFirmwareOnAzure
 */
export interface PrototypeFirmwareOnAzure {
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    blob_name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrototypeFirmwareOnAzure
     */
    assigned_auth_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof PrototypeFirmwareOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the PrototypeFirmwareOnAzure interface.
 */
export function instanceOfPrototypeFirmwareOnAzure(value: object): value is PrototypeFirmwareOnAzure {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('blob_name' in value) || value['blob_name'] === undefined) return false;
    if (!('assigned_auth_ids' in value) || value['assigned_auth_ids'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function PrototypeFirmwareOnAzureFromJSON(json: any): PrototypeFirmwareOnAzure {
    return PrototypeFirmwareOnAzureFromJSONTyped(json, false);
}

export function PrototypeFirmwareOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototypeFirmwareOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'version': json['version'],
        'description': json['description'],
        'blob_name': json['blob_name'],
        'assigned_auth_ids': json['assigned_auth_ids'],
        'created_by': json['created_by'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function PrototypeFirmwareOnAzureToJSON(json: any): PrototypeFirmwareOnAzure {
    return PrototypeFirmwareOnAzureToJSONTyped(json, false);
}

export function PrototypeFirmwareOnAzureToJSONTyped(value?: PrototypeFirmwareOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'version': value['version'],
        'description': value['description'],
        'blob_name': value['blob_name'],
        'assigned_auth_ids': value['assigned_auth_ids'],
        'created_by': value['created_by'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

